<div id="restrictBanner" *ngIf="isShowBlur" class="blur">
  <div *ngIf="isShowRestrict" class="restrict">
    <i class="pi pi-lock"></i>
    <p class="restrict-text">
      Are you an employer? To recruit or hire on the Resume Carousel, post your
      job positions.
    </p>
    <div class="get-started">
      <button
        (click)="goToPrice()"
        class="button-simple lg-20 shock-pink uppercase"
      >
        Get started
      </button>
      <p>Need help? <a (click)="showContactMeDialog()">Contact Us.</a></p>
    </div>
  </div>
</div>
